import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SavedSearch } from '../../../classes/saved-search';
import {SavedSearchLocationType} from '../../../classes/enums';

@Component({
  selector: 'app-saved-searches',
  templateUrl: './saved-searches.component.html',
  styleUrls: ['./saved-searches.component.scss']
})
export class SavedSearchesComponent implements OnInit {
  SavedSearchLocationType = SavedSearchLocationType;

  private _savedSearches: SavedSearch[] = [];
  @Input() set savedSearches( value: SavedSearch[]) {
    this._savedSearches = value;
  }
  get savedSearches(): SavedSearch[] {
    return this._savedSearches;
  }

  @Output() onStartSearchClick: EventEmitter<void> = new EventEmitter();
  @Output() onDeleteAllClick: EventEmitter<void> = new EventEmitter();
  @Output() onDeleteSavedSearchClick: EventEmitter<SavedSearch> = new EventEmitter();
  @Output() onSaveChangesClick: EventEmitter<SavedSearch[]> = new EventEmitter();
  @Output() onSavedSearchClick: EventEmitter<SavedSearch> = new EventEmitter();

  SavedSearch = SavedSearch;

  constructor() { }

  ngOnInit() {}


  saveChangesClicked() {
    this.onSaveChangesClick.emit(this.savedSearches);
  }


}
